import { Component, Input, OnInit } from '@angular/core';
import { WindowRefService } from 'src/app/window-ref.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {
  @Input() type: string;
  contactNumber = "+1 (720) 655-7530";
  email = "info@avantamarketing.com";
  showContactForm = false;
  constructor(private windowRefService: WindowRefService, private fns: AngularFireFunctions) { }

  ngOnInit(): void {
  }

  openUrl(type) {
    let windowToOpen = type === 'phone' ? `tel:${this.contactNumber}` : `mailto:${this.email}`
    this.windowRefService.nativeWindow.open(windowToOpen, '_blank')
  }
}
